import { PayeeTaxDocumentSharePermission } from "@wingspanhq/payments/dist/interfaces";
import { useWSMutation, WSMutationConfig } from "@ws-react-query";
import { QUERY_NOTIFICATIONS_NOTIFICATIONS } from "../../../../../../query/notifications/keys";
import { WSServiceError } from "../../../../../../utils/serviceHelper";
import { updatePayer } from "../../../../../../services/payers";
import { QUERY_PAYER } from "../../../../../../query/payers/keys";

export const useMutationSubmit = (config?: WSMutationConfig<void>) => {
  return useWSMutation<any, WSServiceError, string>(
    async (payerId: string) => {
      return updatePayer(payerId, {
        payeeOwnedData: {
          shareTaxDocument: PayeeTaxDocumentSharePermission.Allow
        }
      });
    },
    {
      dependencies: [QUERY_NOTIFICATIONS_NOTIFICATIONS],
      awaitDependencies: (result, payerId) => [QUERY_PAYER, payerId],
      ...config
    }
  );
};
